import * as v from "valibot";

import { MEMBERS_QUERY } from "@/features/members/graphql/members-query";
import { Members } from "@/features/members/members";

const searchSchema = v.object({
  type: v.optional(
    v.fallback(
      v.union([
        v.literal("active"),
        v.literal("disabled"),
        v.literal("invitations"),
        v.literal("membership-requests"),
      ]),
      "active",
    ),
  ),
  id: v.optional(v.string()),
});

export const Route = createFileRoute({
  component: Members,
  loader: async ({ context, params }) => {
    if (context.urqlClient) {
      await context.urqlClient
        .query(MEMBERS_QUERY, { organizationId: params.orgId })
        .toPromise();
    }
  },
  validateSearch: searchSchema,
});
